import * as PropTypes from 'prop-types';
import * as React from 'react';

var currentYear = () => {
  var d = new Date();
  return d.getFullYear();
};
var defaultFooterText = /*#__PURE__*/React.createElement("p", null, "\xA9 ", currentYear(), " Commonwealth Bank of Australia ABN 48 123 123 124 AFSL and Australian credit licence 234945");
var FooterOrigination = props =>
/*#__PURE__*/
// eslint-disable-next-line
React.createElement("div", {
  className: "footerorigination bg-light",
  "data-hcid": hcid
}, /*#__PURE__*/React.createElement("div", {
  className: props.fluid ? 'container-fluid' : 'container'
}, /*#__PURE__*/React.createElement("div", {
  className: "row"
}, /*#__PURE__*/React.createElement("div", {
  className: "col-12"
}, /*#__PURE__*/React.createElement("footer", {
  role: "contentinfo",
  className: "gutter-px pt-3"
}, props.children || defaultFooterText)))));
var hcid = "".concat(FooterOrigination.name.toLocaleLowerCase(), "-").concat("10.6.2");
FooterOrigination.defaultProps = {
  fluid: true
};
FooterOrigination.propTypes = {
  children: PropTypes.element,
  fluid: PropTypes.bool
};

export { FooterOrigination, currentYear };
